import { Component, effect, inject, OnInit } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { AppConfigService } from '@config/app-config.service';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { languageList } from '@model/language';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '@shared/constants';
import { setDefaultOptions } from 'date-fns';
import { nl } from 'date-fns/locale';
import { register } from 'swiper/element/bundle';

register();

@Component({
  selector: 'ad6-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit {
  private appConfigService = inject(AppConfigService);
  private translateService = inject(TranslateService);

  constructor() {
    effect(() => {
      const translations = this.appConfigService.appConfig()?.translations;
      if (translations) {
        languageList.map(language => {
          const languageTranslations = translations[language];
          if (languageTranslations) {
            this.translateService.setTranslation(
              language,
              languageTranslations,
              true,
            );
          }
        });
      }
    });
  }

  ngOnInit(): void {
    this.translateService.setFallbackLang(Constants.LANGUAGE_CODE);
    this.translateService.use(Constants.LANGUAGE_CODE);

    setDefaultOptions({ locale: nl });

    void SplashScreen.hide();
  }
}
